import React, { Component } from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import PBGUserAgreement from './pbg-user-agreement';
import { formatMessage } from '../../lib/intl';

import '../css/footer.css';

class Footer extends Component {
  constructor(props) {
    super(props);
    this.changeCurrentLanguage = this.changeCurrentLanguage.bind(this);
    this.formatMessage = formatMessage(this.props.intl);
    this.i18n = defineMessages({
      about: {
        id: 'footer.aboutPayByGroup',
        defaultMessage: 'About Key Travel',
      },
      language: {
        id: 'footer.languages.language',
        defaultMessage: 'Language'
      },
      privacyPolicy: {
        id: 'footer.privacyPolicy',
        defaultMessage: 'Privacy Policy',
      },
      userAgreement: {
        id: 'footer.userAgreement',
        defaultMessage: 'User Agreement',
      },
    });
  }

  changeCurrentLanguage(ev) {
    this.props.onLanguageChange(ev);
  }

  render() {
    return (
      <div className="footer">
        <div className="container nav flex-column flex-sm-row">
          <a
            href="https://paybygroup.com/business"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link"
          >
            {this.formatMessage(this.i18n.about)}
          </a>

          <label className="nav-link">
            <select
              className="custom-select"
              value=""
              onChange={this.changeCurrentLanguage}
            >
              <option>{this.formatMessage(this.i18n.language)} &#9662;</option>
              <option value="en">English</option>
              <option value="es">Español (Latinoamérica)</option>
              <option value="es-ES">Español (España)</option>
              <option value="da">Dansk</option>
              <option value="fr">Français</option>
              <option value="it">Italiano</option>
            </select>
          </label>

          <a
            href="https://www.paybygroup.com/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link"
          >
            {this.formatMessage(this.i18n.privacyPolicy)}
          </a>

          <PBGUserAgreement
            text={this.formatMessage(this.i18n.userAgreement)}
            className="nav-link"
          />

          <span className="nav-link">
            Key Travel {new Date().getFullYear()} &copy;
          </span>
        </div>
      </div>
    );
  }
}

Footer.defaultProps = {
  onLanguageChange: () => { },
};

export default injectIntl(Footer);



// WEBPACK FOOTER //
// ./src/desktop/components/footer.js